export const MARKER_HIGHLIGHTED_COLOUR = 'blue';
